/* global canManageRisks canManageIssues canManageDecisions */
/* global fetchGeneralRisksUrl fetchGeneralIssuesUrl fetchGeneralDecisionsUrl */
/* global fetchGeneralRiskBudgetLinesUrl fetchGeneralRiskTypesUrl fetchGeneralRiskImpactsUrl fetchGeneralImpactCategoriesUrl */
/* global fetchGeneralRiskProbabilitiesUrl fetchGeneralRiskStatusesUrl updateGeneralRiskHotStatusUrl updateGeneralIssueHotStatusUrl */
/* global updateGeneralDecisionHotStatusUrl deleteGeneralRiskUrl restoreGeneralRiskUrl forceDeleteGeneralRiskUrl fetchTrashedGeneralRisksUrl deleteGeneralIssueUrl deleteGeneralDecisionUrl listUsersUrl */
/* global generalRisksExportUrl fetchGeneralRiskUrl reorderGeneralRiskUrl fetchGeneralIssueUrl fetchGeneralDecisionUrl getGeneralRiskPriorityUrl */
/* global storeGeneralRiskUrl updateGeneralRiskUrl storeGeneralIssueUrl  updateGeneralIssueUrl  storeGeneralDecisionUrl updateGeneralDecisionUrl */
/* global reorderGeneralIssueUrl reorderGeneralDecisionUrl fetchEventDepartmentsOptionsUrl */
/* global importGeneralRisksUrl importGeneralIssuesUrl importGeneralDecisionsUrl */
/* global canCreateAssumption canUpdateAssumption canDeleteAssumption canDeleteAssumptionItem canVerifyAssumptionItem */
/* global bulkDeleteCentralAssumptionGroupUrl deleteCentralAssumptionAttachmentUrl downloadCentralAssumptionAttachmentUrl importCentralAssumptionsUrl updateAssumptionCategoriesOrderUrl */
/* global storeCentralAssumptionGroupUrl updateCentralAssumptionGroupUrl fetchVenuesOptionsUrl */

import React, { useMemo } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';
import Select from 'react-select';

import CentralAssumptionsIndex from '../central_assumptions/CentralAssumptionsIndex';
import { CUSTOM_STYLES, OPPORTUNITY_TYPE, RAID_OPTIONS, SOURCE_TYPE_VENUE } from '../radio/constants';
import { RaidProvider, useRaidContext } from '../radio/context/RaidContext';
import GeneralDecisionsIndex from '../radio/register/general_decision/GeneralDecisionsIndex';
import GeneralIssuesIndex from '../radio/register/general_issue/GeneralIssuesIndex';
import GeneralRisksIndex from '../radio/register/general_risk/GeneralRisksIndex';

import Tabs, { RenderStrategyAlways } from 'CommonComponents/Tabs';

import { ConfirmationModalProvider } from 'Context/ConfirmationModalContext';
import { UsersProvider } from 'Context/UsersContext';

// The venue page has no opportunity modal to add one from.
const ADD_NEW_OPTIONS = RAID_OPTIONS.filter((option) => option.value !== OPPORTUNITY_TYPE);

export default function VenueRaidApp({
    canCreateAssumption,
    canUpdateAssumption,
    canDeleteAssumption,
    canDeleteAssumptionItem,
    canVerifyAssumptionItem,
    bulkDeleteCentralAssumptionGroupUrl,
    deleteCentralAssumptionAttachmentUrl,
    downloadCentralAssumptionAttachmentUrl,
    importCentralAssumptionsUrl,
    storeCentralAssumptionGroupUrl,
    updateCentralAssumptionGroupUrl,
    updateAssumptionCategoriesOrderUrl,
    fetchVenuesOptionsUrl,
}) {
    const { canManageRisks, canManageIssues, canManageDecisions, createByType, importByType, currentVenue } = useRaidContext();

    const tabs = useMemo(
        () => [
            {
                id: 'venue-raid---risks',
                title: $t('Risks'),
                content: () => <GeneralRisksIndex />,
            },
            {
                id: 'venue-raid---assumptions',
                title: $t('Assumptions'),
                content: () => (
                    <CentralAssumptionsIndex
                        venueId={currentVenue.id}
                        canCreate={canCreateAssumption}
                        canUpdate={canUpdateAssumption}
                        canDelete={canDeleteAssumption}
                        canDeleteAssumption={canDeleteAssumptionItem}
                        canVerifyAssumption={canVerifyAssumptionItem}
                        bulkDeleteCentralAssumptionGroupUrl={bulkDeleteCentralAssumptionGroupUrl}
                        deleteCentralAssumptionAttachmentUrl={deleteCentralAssumptionAttachmentUrl}
                        downloadCentralAssumptionAttachmentUrl={downloadCentralAssumptionAttachmentUrl}
                        importCentralAssumptionsUrl={importCentralAssumptionsUrl}
                        storeCentralAssumptionGroupUrl={storeCentralAssumptionGroupUrl}
                        updateCentralAssumptionGroupUrl={updateCentralAssumptionGroupUrl}
                        updateAssumptionCategoriesOrderUrl={updateAssumptionCategoriesOrderUrl}
                        fetchVenuesOptionsUrl={fetchVenuesOptionsUrl}
                    />
                ),
            },
            {
                id: 'venue-raid---issues',
                title: $t('Issues'),
                content: () => <GeneralIssuesIndex />,
            },
            {
                id: 'venue-raid---decisions',
                title: $t('Decisions'),
                content: () => <GeneralDecisionsIndex />,
            },
        ],
        [],
    );

    return (
        <Tabs
            tabs={tabs}
            renderStrategy={RenderStrategyAlways} // Always is mandatory here to keep the state of filters and modals in each tab, but it can be changed to OnVisit if we want to reset those states when switching tabs
            actions={[
                {
                    content: () => {
                        return (
                            (!!canManageRisks || !!canManageIssues || !!canManageDecisions) && (
                                <div className="tw-flex tw-justify-end tw-items-center tw-w-full tw-mb-2">
                                    <div className="dropdown mr-2">
                                        <Select
                                            name="import-from-file"
                                            options={RAID_OPTIONS}
                                            menuPortalTarget={document.body} // Renders the menu in the body
                                            styles={{
                                                ...CUSTOM_STYLES,
                                                menuPortal: (base) => ({ ...base, zIndex: 100 }), // Ensures the menu is above other content
                                            }}
                                            onChange={(option) => importByType(option.value)}
                                            defaultValue={{}}
                                            value={null}
                                            placeholder={$t('Import from file')}
                                            isSearchable={false}
                                        />
                                    </div>
                                    <div className="dropdown mr-2">
                                        <Select
                                            name="import-from-file"
                                            options={ADD_NEW_OPTIONS}
                                            menuPortalTarget={document.body} // Renders the menu in the body
                                            styles={{
                                                ...CUSTOM_STYLES,
                                                menuPortal: (base) => ({ ...base, zIndex: 100 }), // Ensures the menu is above other content
                                            }}
                                            onChange={(option) => createByType(option.value)}
                                            defaultValue={{}}
                                            value={null}
                                            placeholder={$t('Add New')}
                                            isSearchable={false}
                                        />
                                    </div>
                                </div>
                            )
                        );
                    },
                },
            ]}
            maxScreenHeight
        />
    );
}

if (document.getElementById('VenueRaidApp')) {
    var root = document.getElementById('VenueRaidApp');
    var data = root.dataset;
    var venue = JSON.parse(data.venue);

    ReactDOM.render(
        <App>
            <ConfirmationModalProvider>
                <UsersProvider fetchUrl={listUsersUrl}>
                    <RaidProvider
                        source={SOURCE_TYPE_VENUE}
                        venue={venue}
                        canManageRisks={canManageRisks}
                        canManageIssues={canManageIssues}
                        canManageDecisions={canManageDecisions}
                        routes={{
                            // Risks routes
                            fetchGeneralRisksUrl,
                            generalRisksExportUrl,
                            fetchGeneralRiskTypesUrl,
                            fetchGeneralRiskImpactsUrl,
                            fetchGeneralRiskProbabilitiesUrl,
                            fetchGeneralRiskStatusesUrl,
                            getGeneralRiskPriorityUrl,
                            updateGeneralRiskHotStatusUrl,
                            reorderGeneralRiskUrl,
                            fetchGeneralRiskUrl,
                            storeGeneralRiskUrl,
                            updateGeneralRiskUrl,
                            fetchGeneralRiskBudgetLinesUrl,
                            deleteGeneralRiskUrl,
                            restoreGeneralRiskUrl,
                            forceDeleteGeneralRiskUrl,
                            fetchTrashedGeneralRisksUrl,
                            importGeneralRisksUrl,

                            // Issues routes
                            fetchGeneralIssuesUrl,
                            updateGeneralIssueHotStatusUrl,
                            deleteGeneralIssueUrl,
                            fetchGeneralIssueUrl,
                            storeGeneralIssueUrl,
                            updateGeneralIssueUrl,
                            reorderGeneralIssueUrl,
                            importGeneralIssuesUrl,

                            // Decisions routes
                            fetchGeneralDecisionsUrl,
                            updateGeneralDecisionHotStatusUrl,
                            deleteGeneralDecisionUrl,
                            fetchGeneralDecisionUrl,
                            storeGeneralDecisionUrl,
                            updateGeneralDecisionUrl,
                            reorderGeneralDecisionUrl,
                            importGeneralDecisionsUrl,

                            // Other routes
                            fetchGeneralImpactCategoriesUrl,
                            fetchEventDepartmentsOptionsUrl,
                        }}
                    >
                        <VenueRaidApp
                            canCreateAssumption={canCreateAssumption}
                            canUpdateAssumption={canUpdateAssumption}
                            canDeleteAssumption={canDeleteAssumption}
                            canDeleteAssumptionItem={canDeleteAssumptionItem}
                            canVerifyAssumptionItem={canVerifyAssumptionItem}
                            bulkDeleteCentralAssumptionGroupUrl={bulkDeleteCentralAssumptionGroupUrl}
                            deleteCentralAssumptionAttachmentUrl={deleteCentralAssumptionAttachmentUrl}
                            downloadCentralAssumptionAttachmentUrl={downloadCentralAssumptionAttachmentUrl}
                            importCentralAssumptionsUrl={importCentralAssumptionsUrl}
                            updateAssumptionCategoriesOrderUrl={updateAssumptionCategoriesOrderUrl}
                            storeCentralAssumptionGroupUrl={storeCentralAssumptionGroupUrl}
                            updateCentralAssumptionGroupUrl={updateCentralAssumptionGroupUrl}
                            fetchVenuesOptionsUrl={fetchVenuesOptionsUrl}
                        />
                    </RaidProvider>
                </UsersProvider>
            </ConfirmationModalProvider>
        </App>,
        root,
    );
}
